const state = {
	states: {},
}

const getters = {
	states(currentState) {
		return currentState.states
	},
}

const actions = {
	saveState({ commit }, urlState) {
		commit('saveState', urlState)
	},
	clearState({ commit }, url) {
		commit('clearState', url)
	},
	clearStates({ commit }, url) {
		commit('clearStates', url)
	},
}

const mutations = {
	saveState(currentState, { path, query }) {
		currentState.states[path] = query
	},
	clearState(currentState, url) {
		delete currentState.states[url]
	},
	clearStates(currentState, url) {
		currentState.states = Object.keys(currentState.states).reduce((acc, stateUrl) => {
			if ((new RegExp(`^${stateUrl.replace(/\//g, '\\/')}`)).test(url)) {
				acc[stateUrl] = currentState.states[stateUrl]
			}
			return acc
		}, {})
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
